/* eslint-disable no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface TrendsState {
  devicesCount: number
  devicesCountFetched: boolean
}

const initialState: TrendsState = {
  devicesCount: 0,
  devicesCountFetched: false
}

export const trendsSlice = createSlice({
  name: 'trends',
  initialState,
  reducers: {
    setDevicesCount: (state: TrendsState, action: PayloadAction<number>) => {
      state.devicesCount = action.payload
      state.devicesCountFetched = true
    },
    setDevicesCountFetched: (state, action) => {
      state.devicesCountFetched = action.payload
    }
  }
})

export const devicesCountSelector = (state: RootState): number => state.trends.devicesCount
export const devicesCountFetchedSelector = (state: RootState) => state.trends.devicesCountFetched

export const { setDevicesCount, setDevicesCountFetched } = trendsSlice.actions

export default trendsSlice.reducer
